import { encode as base64_encode } from 'base-64';
import { postApi, baseURL } from '../components/Utility'
import {
    action,
    makeObservable,
    observable,
} from 'mobx';

class FuelRefilledReportStore {
    loading = false
    fuelRefilledReport = []
    rootStore

    constructor(rootStore) {
        makeObservable(this, {
            fuelRefilledReport: observable,
            loadData: action,
            exportExcel: action,
            exportpdf: action
        });
        this.rootStore = rootStore;

    }

    async loadData({ companyId, vehicleId, offset, limit, driverId, fromDate, toDate, pageNo }) {
        this.loading = true
        var postData = { "companyId": companyId, "vehicleId": vehicleId, "fromDate": fromDate, "toDate": toDate, "offset": offset, "limit": limit, "page": pageNo }

        const base64Input = await base64_encode(JSON.stringify(postData));

        var response = await postApi.getClient().post("index.php?c=vehicle&a=fuelrefill", "postData=" + base64Input);

        this.fuelRefilledReport = response?.data?.data?.fuelrefill?.fuelrefill;
        this.total = response?.data?.data?.TotalCount
        this.loading = false
    }


    async exportExcel(getData) {
        let lang = "english";
        window.location.href =
            baseURL +
            "index.php?c=vehicle&a=exportfuelrefillExcelNew&cid=" +
            getData.companyId +
            "&userId=" +
            getData.userId +
            "&vid=" +
            getData.vehicleId +
            "&fD=" +
            getData.fromDate +
            "&tD=" +
            getData.toDate +
            "&colList=" +
            getData.colList +
            "&language=" +
            lang;
    }

    async exportpdf(getData) {
        let lang = "english";
        window.location.href =
            baseURL +
            "index.php?c=vehicle&a=exportfuelrefillpdfNew&cid=" +
            getData.companyId +
            "&userId=" +
            getData.userId +
            "&vid=" +
            getData.vehicleId +
            "&fD=" +
            getData.fromDate +
            "&tD=" +
            getData.toDate +
            "&colList=" +
            getData.colList +
            "&language=" +
            lang;
    }
}

export default FuelRefilledReportStore;
